<template>
  <div>
    <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
      <h2 class="mb-10">{{ title }}</h2>
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Materia *">
            <b-form-textarea
              :state="errors.has('custom-document.matter') ? false : null"
              data-cy="matter"
              data-vv-as="materia"
              name="matter"
              maxLength="500"
              rows="3"
              type="text"
              v-model="formData.matter"
              v-validate="'required'"
            />
            <div class="row justify-content-between">
              <div class="col-md-6 text-left">
                <div
                  v-if="errors.has('custom-document.matter')"
                  class="con-text-validation span-text-validation-danger v-enter-to"
                >
                  <span class="span-text-validation">
                    {{ errors.first('custom-document.matter') }}
                  </span>
                </div>
              </div>
              <div class="col-md-6 text-right">
                <small v-tooltip="'Contador de caracteres'">
                  {{formData.matter.length}}/500
                </small>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group label="Vistos *">
            <b-form-textarea
              :state="errors.has('custom-document.seen') ? false : null"
              data-cy="seen"
              data-vv-as="vistos"
              name="seen"
              maxLength="5000"
              rows="3"
              type="text"
              v-model="formData.seen"
              v-validate="'required'"
            />
            <div class="row justify-content-between">
              <div class="col-md-6 text-left">
                <div
                  v-if="errors.has('custom-document.seen')"
                  class="con-text-validation span-text-validation-danger v-enter-to"
                >
                  <span class="span-text-validation">
                    {{ errors.first('custom-document.seen') }}
                  </span>
                </div>
              </div>
              <div class="col-md-6 text-right">
                <small v-tooltip="'Contador de caracteres'">
                  {{formData.seen.length}}/5000
                </small>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group label="Considerando *">
            <b-form-textarea
              :state="errors.has('custom-document.considering') ? false : null"
              data-cy="considering"
              data-vv-as="considerando"
              name="considering"
              maxLength="8000"
              rows="3"
              type="text"
              v-model="formData.considering"
              v-validate="'required'"
            />
            <div class="row justify-content-between">
              <div class="col-md-6 text-left">
                <div
                  v-if="errors.has('custom-document.considering')"
                  class="con-text-validation span-text-validation-danger v-enter-to"
                >
                  <span class="span-text-validation">
                    {{ errors.first('custom-document.considering') }}
                  </span>
                </div>
              </div>
              <div class="col-md-6 text-right">
                <small v-tooltip="'Contador de caracteres'">
                  {{formData.considering.length}}/8000
                </small>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group label="Resuelvo *">
            <editor-text
              :danger="errors.has('custom-document.resolved')"
              :danger-text="errors.first('custom-document.resolved')"
              data-cy="resolved"
              data-vv-as="resuelvo"
              :max-length="maxLengthResolved"
              name="resolved"
              ref="resolved"
              v-validate="'required'"
              v-model="formData.resolved"
              with-counter
            />
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group label="Imperativos *">
            <b-form-checkbox-group
              data-cy="imperatives"
              data-vv-as="imperativos"
              name="imperatives"
              :options="optionsImperatives"
              v-model="formData.imperatives"
              v-validate="'required'"
            />
            <div
              v-if="errors.has('custom-document.imperatives')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document.imperatives') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12 mt-3">
          <b-form-group label="Cierre de la resolución">
            <b-form-checkbox
              data-cy="closing-resolution"
              v-model="formData.closingResolution"
              name="closingResolution"
              :value="true"
              :unchecked-value="false"
            >
              Por orden del señor Gobernador Regional en su calidad de ejecutivo del Gobierno
              Regional de la Región de Valparaíso.
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div class="col-md-6 mt-2">
          Orientación de documento
          <div class="row mt-3">
            <div class="col-md-4">
              <vs-radio
                vs-name="portrait"
                vs-value="Portrait"
                v-model="formData.orientation"
                data-cy="portrait"
              >
                Vertical
              </vs-radio>
            </div>
            <div class="col-md-4">
              <vs-radio
                vs-name="landscape"
                vs-value="Landscape"
                v-model="formData.orientation"
                data-cy="landscape"
              >
                Horizontal
              </vs-radio>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row align-items-center mt-5">
            <div class="col-md-12">
              <label>Adjuntos</label>
            </div>
            <div class="col-md-3 align-items-end">
              <UploadFile
                permission="*"
                accept="application/pdf, .doc, .docx, .xlsx, .ppt"
                text="Seleccionar documentos"
                v-model="fileOthers"
                upload-to="ed"
                :button-class="{ 'btn-block': true,
                 'mb-5': errors.has('custom-document.fileName') }"
                container-class="w-100"
                @input="addOthersFile()"
              />
            </div>
          </div>
          <div class="row align-items-center mt-1">
            <div class="col-md-3 align-items-end">
              <b-button
                variant="secondary"
                class="btn-icon mt-1"
                data-cy= "from-repository"
                v-has-permission="'ED060'"
                v-b-modal="'add-file-repository'"
              >
                <feather-icon icon="ServerIcon"/>
                Desde el repositorio
              </b-button>
            </div>
            <div class="col-2" v-for="file in formData.attachments" :key="file.id">
              <div class="d-flex flex-column align-items-center">
                <vs-icon icon="description" size="25px" color="primary" />
                <b class="text-truncate w-100 text-center">{{ file.name }}</b>
                <vs-button
                  color="danger"
                  type="flat"
                  icon="clear"
                  @click="removeOthersFile(file.id)"
                />
              </div>
            </div>
          </div>
          <div
            v-if="!!error.messageOthers"
            class="con-text-validation span-text-validation-danger
          vs-input--text-validation-span v-enter-to text-left"
          >
            <span class="span-text-validation">
              {{ error.messageOthers }}
            </span>
          </div>
        </div>
      </div>
      <FormButtons
        :saving="saving"
        :back="back"
        :save="save"
        :saveDraft="saveDraft"
      />
      <SelectDocRepository
        :add-file="addFileRepo"
        :files="formData.attachments"
        :remove-file="removeOthersFile"
      />
    </form>
  </div>
</template>
<script>
import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import { showToast } from '@/febos/global/customDocuments/utils/showToast';
import FindCodeGroupMixin
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/FindCodeGroupMixin';
import EditorText from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/EditorText';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import SelectDocRepository
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectDocRepository';
import FormButtons from '@/febos/global/customDocuments/components/FormButtons';

export default {
  name: 'ResForm',
  components: { SelectDocRepository, UploadFile, EditorText, FormButtons },
  mixins: [FindCodeGroupMixin],
  props: {
    title: {
      type: String,
      required: true
    },
    typeDocument: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      error: {
        messageOthers: ''
      },
      formData: {
        matter: '',
        orientation: 'Portrait',
        seen: '',
        considering: '',
        resolved: '',
        imperatives: [],
        closingResolution: false,
        attachments: []
      },
      fileOthers: {},
      optionsImperatives: [
        { value: 'anótese', text: 'Anótese' },
        { value: 'comuníquese', text: 'Comuníquese' },
        { value: 'publíquese', text: 'Publíquese' },
        { value: 'archívese', text: 'Archívese' },
        { value: 'regístrese', text: 'Regístrese' }
      ],
      saving: false,
      maxLengthResolved: 100000
    };
  },
  computed: {
    imperativesFormat() {
      if (this.formData.imperatives.length === 1) {
        return this.formData.imperatives[0];
      }
      let { imperatives } = this.formData;
      if (this.formData.imperatives.some((element) => element === 'regístrese')) {
        imperatives = this.formData.imperatives.filter((element) => element !== 'regístrese');
        imperatives.push('regístrese');
      }
      return `${imperatives.slice(0, -1).join(', ')} y ${imperatives.slice(-1)}`;
    }
  },
  methods: {
    async addFileRepo(file) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.formData.attachments.push(file);
      this.error.message = '';
    },
    async addOthersFile() {
      if (!Object.keys(this.fileOthers).length) {
        return;
      }

      if (this.fileOthers.failed) {
        this.error.messageOthers = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.formData.attachments.push(this.fileOthers);
      this.error.messageOthers = '';
    },
    removeOthersFile(fileId) {
      this.formData.attachments = this.formData.attachments
        .filter((file) => file.id !== fileId);
    },
    async validateFormRES(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async save() {
      const isValid = await this.validateFormRES('custom-document');
      if (!isValid) {
        return;
      }

      const textPlainResolved = this.$refs.resolved.getTextPlain();
      if (textPlainResolved.length > this.maxLengthResolved) {
        this.$bvToast.toast(
          'El campo resuelvo tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }

      this.saving = true;
      this.$bvToast.toast(
        'Guardando documento',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      const codeGroup = await this.findCodeGroup();
      const payload = {
        type: this.$route.params.type,
        query: this.$route.query,
        formData: {
          ...this.formData,
          imperatives: this.imperativesFormat,
          textPlainResolved,
          codeGroup,
          metadata: { orientation: this.formData.orientation }
        }
      };
      const response = await ioCreateCustomDocument(payload);
      await this.generatePdfRES(response.data.document.id);
    },
    async saveDraft() {
      const isValid = await this.validateFormRES('custom-document');
      if (!isValid) {
        return;
      }

      const textPlainResolved = this.$refs.resolved.getTextPlain();
      if (textPlainResolved.length > this.maxLengthResolved) {
        this.$bvToast.toast(
          'El campo resuelvo tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }

      this.saving = true;
      showToast(this, 'Guardando documento', 'En camino...', { 
        variant: 'primary', 
        autoHideDelay: 2000 
      });
      
      const codeGroup = await this.findCodeGroup();
      const payload = {
        type: this.$route.params.type,
        query: {
          ...this.$route.query,
          numerar: 'no',
        },
        formData: {
          ...this.formData,
          imperatives: this.imperativesFormat,
          textPlainResolved,
          codeGroup,
          metadata: { orientation: this.formData.orientation },
          status: '3'
        }
      };

      try {
        const response = await ioCreateCustomDocument(payload);
        await this.generatePdfRES(response.data.document.id);
      } finally {
        this.saving = false;
      }
    },
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    async generatePdfRES(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument(this.typeDocument, id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      this.back();
    }
  }
};
</script>
